// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorPromotions = (client) => ({
    /**
     * `POST /vendor/promotions/:id/buy-rules/batch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBatchBuyRules
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/buy-rules/batch/route.ts
     */
    batchBuyRules: (id, body, query, headers) => client.fetch(buildPath("/vendor/promotions/:id/buy-rules/batch", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/promotions/:id/rules/batch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBatchRules
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/rules/batch/route.ts
     */
    batchRules: (id, body, query, headers) => client.fetch(buildPath("/vendor/promotions/:id/rules/batch", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/promotions/:id/target-rules/batch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorBatchTargetRules
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/target-rules/batch/route.ts
     */
    batchTargetRules: (id, body, query, headers) => client.fetch(buildPath("/vendor/promotions/:id/target-rules/batch", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/promotions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreatePromotion
     * @source packages/modules/b2c-core/src/api/vendor/promotions/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/promotions", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/promotions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeletePromotionById
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/promotions/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/promotions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListPromotions
     * @source packages/modules/b2c-core/src/api/vendor/promotions/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/promotions", { method: "GET", query, headers }),
    /**
     * `GET /vendor/promotions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPromotionById
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/promotions/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/promotions/:id/:rule_type`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPromotionsIdRuleType
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/[rule_type]/route.ts
     */
    retrieveRule: (id, ruleType, query, headers) => client.fetch(buildPath("/vendor/promotions/:id/:rule_type", [id, ruleType]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/promotions/rule-attribute-options/:rule_type`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPromotionsRuleAttributeOptionsRule
     * @source packages/modules/b2c-core/src/api/vendor/promotions/rule-attribute-options/[rule_type]/route.ts
     */
    retrieveRuleAttributeOption: (ruleType, query, headers) => client.fetch(buildPath("/vendor/promotions/rule-attribute-options/:rule_type", [ruleType]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/promotions/rule-value-options/:rule_type/:rule_attribute_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/modules/b2c-core/src/api/vendor/promotions/rule-value-options/[rule_type]/[rule_attribute_id]/route.ts
     */
    retrieveRuleValueOption: (ruleType, ruleAttributeId, query, headers) => client.fetch(buildPath("/vendor/promotions/rule-value-options/:rule_type/:rule_attribute_id", [ruleType, ruleAttributeId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/promotions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdatePromotion
     * @source packages/modules/b2c-core/src/api/vendor/promotions/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/promotions/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=promotions.js.map